import { render, staticRenderFns } from "./ObjectStoresStorageOverview.vue?vue&type=template&id=18de9ef4"
import script from "./ObjectStoresStorageOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoresStorageOverview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports